import { actionTypes } from 'data'
import { takeEvery } from 'redux-saga/effects'

const openChat = function () {
  window.zE('webWidget', 'open')
}

const closeChat = function () {
  window.zE('webWidget', 'close')
}

const showChatButton = function () {
  window.$zopim.livechat.button.show()
}

const hideChatButton = function () {
  window.$zopim.livechat.button.hide()
}

export default function* zendeskSagas() {
  yield takeEvery(actionTypes.app.zendesk.OPEN_CHAT, openChat)
  yield takeEvery(actionTypes.app.zendesk.CLOSE_CHAT, closeChat)
  yield takeEvery(actionTypes.app.zendesk.SHOW_CHAT_BUTTON, showChatButton)
  yield takeEvery(actionTypes.app.zendesk.HIDE_CHAT_BUTTON, hideChatButton)
}
